import FootballGameContext from "../../football/context/football-game-context";
import DefaultFlagFootballConfig from "../config/default";
import { deepCopy } from "../../../services/common/object-util";

export default class FlagFootballGameContext extends FootballGameContext {
    constructor(props = {}) {
        // Only fall back to the flag default when the caller supplied no
        // config — unconditionally overriding dropped the real event/season
        // configuration passed by ContextService.createContext.
        super({
            ...props,
            config: props.config ?? deepCopy(DefaultFlagFootballConfig)
        });
    }
}
